import './../map.css';
import * as $ from 'jquery';
import 'bootstrap-datepicker';
import {useGeographic} from "ol/proj";
import {MapView} from "./MapView";
import {MapFilters} from "./MapFilters";
import {TopNavigation} from "./TopNavigation";

useGeographic();

$.fn.datepicker['dates']['sr'] = {
    days: ["Недеља", "Понедељак", "Уторак", "Среда", "Четвртак", "Петак", "Субота"],
    daysShort: ["Нед", "Пон", "Уто", "Сре", "Чет", "Пет", "Суб"],
    daysMin: ["Н", "По", "У", "Ср", "Ч", "Пе", "Су"],
    months: ["Јануар", "Фебруар", "Март", "Април", "Мај", "Јун", "Јул", "Август", "Септембар", "Октобар", "Новембар", "Децембар"],
    monthsShort: ["Јан", "Феб", "Мар", "Апр", "Мај", "Јун", "Јул", "Авг", "Сеп", "Окт", "Нов", "Дец"],
    today: "Данас",
    clear: "Обриши",
    weekStart: 1,
    format: "dd.mm.yyyy."
};

$(() => {
    MapView.setup();
    TopNavigation.setup();
    MapFilters.setup();
    MapView.reloadMapData();
});
